"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridUtils = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
exports.GridUtils = {
    // 获取挂单价数组 结果为升序 example: 1,2,3...
    getPriceInterverArr(top, bottom, row, gridType) {
        if (!Number(top) || !Number(bottom) || !Number(row) || Number(row) < 2 || Number(top) <= Number(bottom)) {
            throw "params has wrong";
        }
        const _top = new trade_utils_lib_1.SafeDecimal(top);
        const _bottom = new trade_utils_lib_1.SafeDecimal(bottom);
        const _row = new trade_utils_lib_1.SafeDecimal(row);
        let priceArr = [];
        if (gridType === "arithmetic") {
            const _step = _top.sub(_bottom).div(_row.sub(1));
            for (let i = 0; i < _row.toNumber(); i++) {
                const price = _bottom.add(_step.mul(i));
                priceArr.push(price);
            }
        }
        else {
            // const q = Math.pow(an / a1, 1 / (n - 1));
            // const sequence = Array.from({ length: n }, (_, index) => a1 * Math.pow(q, index));
            const one = new trade_utils_lib_1.SafeDecimal(1);
            const n = _row;
            const q = trade_utils_lib_1.SafeDecimal.pow(_top.div(_bottom), one.div(n.sub(one)));
            priceArr = Array.from({ length: n.toNumber() }, (_, index) => _bottom.mul(trade_utils_lib_1.SafeDecimal.pow(q, index)));
        }
        priceArr[priceArr.length - 1] = _top;
        return priceArr;
    },
    /// 检测必要的参数是否为空
    checkRequiredParamsEmpty(top, bottom, count) {
        const errors = [];
        if (!Number(bottom)) {
            errors.push("grid_order_low");
        }
        if (!Number(top)) {
            errors.push("grid_order_high");
        }
        if (!Number(count)) {
            errors.push("gird_row_count");
        }
        return errors;
    },
};
